// Las columnas DATE (renovación, inicio de contrato, vencimiento de tareas) no
// tienen hora ni zona, pero el driver de Postgres las entrega como medianoche
// en la zona del servidor: en Heroku llegan como 2026-10-15T00:00:00Z, que en
// México es el 14 a las 18:00. Se toma sólo la parte AAAA-MM-DD y se arma el
// día en la zona del navegador, que es el día que alguien capturó.
export function dayOf(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const [y, m, d] = String(value).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

// Inverso de dayOf: el día local como AAAA-MM-DD. toISOString() pasaría por
// UTC y, según la zona, guardaría el día anterior o el siguiente.
export function dayValue(date) {
  if (!date) return null;
  const d = date instanceof Date ? date : dayOf(date);
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, '0'),
    String(d.getDate()).padStart(2, '0'),
  ].join('-');
}
